/** Lowercase domains — keep in sync with handlers/emailpolicy.go */
export const BLOCKED_CONSUMER_EMAIL_DOMAINS = new Set([
  "gmail.com",
  "googlemail.com",
  "yahoo.com",
  "yahoo.co.uk",
  "yahoo.co.in",
  "yahoo.fr",
  "yahoo.de",
  "ymail.com",
  "outlook.com",
  "hotmail.com",
  "live.com",
  "msn.com",
  "icloud.com",
  "me.com",
  "mac.com",
  "aol.com",
  "protonmail.com",
  "proton.me",
  "gmx.com",
  "gmx.net",
  "gmx.de",
  "mail.com",
  "yandex.com",
  "yandex.ru",
  "mail.ru",
  "inbox.ru",
  "list.ru",
  "bk.ru",
  "qq.com",
  "163.com",
  "126.com",
  "sina.com",
  "hey.com",
  "tutanota.com",
  "tutanota.de",
  "duck.com",
  "pm.me",
]);

export function isBlockedConsumerEmail(email: string): boolean {
  const e = email.trim().toLowerCase();
  const at = e.lastIndexOf("@");
  if (at <= 0) return false;
  const domain = e.slice(at + 1);
  return BLOCKED_CONSUMER_EMAIL_DOMAINS.has(domain);
}
